(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m2-heritage-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('m2-heritage-look')) {
  customElements.define('m2-heritage-look', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.view = this.dataset.defaultView || 'full';
      this.index = 0;
      this.products = Array.from(this.querySelectorAll('[data-look-product]'));
      this.choices = Array.from(this.querySelectorAll('[data-look-choice]'));
      this.querySelectorAll('[data-look-controls]').forEach(n => n.hidden = false);
      this.choices.forEach(n => { n.setAttribute('role', 'button'); n.removeAttribute('aria-current'); });
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-look-choice]');
        const view = event.target.closest('[data-look-view]');
        if (choice && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault(); this.index = Number(choice.dataset.lookChoice); this.update(true);
        } else if (view) { this.view = view.dataset.lookView; this.update(false); }
      }, {signal:this.abort.signal});
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('[data-look-choice]')) { event.preventDefault(); event.target.click(); }
      }, {signal:this.abort.signal});
      document.addEventListener('shopify:block:select', event => {
        const index = this.products.findIndex(n => n.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.index = index; this.update(false); }
      }, {signal:this.abort.signal});
      this.update(false);
    }
    update(announce) {
      this.products.forEach((n, i) => {
        n.hidden = i !== this.index;
        n.querySelector('[data-look-full]').hidden = this.view !== 'full';
        n.querySelector('[data-look-detail]').hidden = this.view !== 'detail';
      });
      this.choices.forEach((n, i) => n.setAttribute('aria-pressed', String(i === this.index)));
      this.querySelectorAll('[data-look-view]').forEach(n => n.setAttribute('aria-pressed', String(n.dataset.lookView === this.view)));
      if (announce && this.products[this.index]) this.querySelector('[data-look-status]').textContent = this.products[this.index].dataset.label;
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
